import { render, staticRenderFns } from "./zjdj.vue?vue&type=template&id=0f7480da&scoped=true&"
import script from "./zjdj.vue?vue&type=script&lang=js&"
export * from "./zjdj.vue?vue&type=script&lang=js&"
import style0 from "./zjdj.vue?vue&type=style&index=0&id=0f7480da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7480da",
  null
  
)

export default component.exports